// extracted by mini-css-extract-plugin
export var chev = "MobileNavigation-module--chev--vaa4b";
export var container = "MobileNavigation-module--container--CCIOS";
export var currentLang = "MobileNavigation-module--currentLang--xa8ry";
export var currentLangText = "MobileNavigation-module--currentLangText--fijXj";
export var langButton = "MobileNavigation-module--langButton--3WHZC";
export var myPagesChapter = "MobileNavigation-module--myPagesChapter--nIG+G";
export var nav = "MobileNavigation-module--nav--xOy1t";
export var navItem = "MobileNavigation-module--navItem--Qz7Gw";
export var navItemChapter = "MobileNavigation-module--navItemChapter--EHgnl";
export var navItemChapter__open = "MobileNavigation-module--navItemChapter__open--juIYD";
export var navList = "MobileNavigation-module--navList--xPYCF";
export var showMobileMenu = "MobileNavigation-module--showMobileMenu--8ZhDL";
export var showNavigation = "MobileNavigation-module--showNavigation--rYN9X";
export var subchapters = "MobileNavigation-module--subchapters--S4x5J";
export var subchapters__open = "MobileNavigation-module--subchapters__open--9Sg5c";